import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const LoginPage = lazy(() =>
  import('@/modules/auth/LoginPage').then((m) => ({ default: m.LoginPage })),
);

interface LoginSearch {
  /** Path to return to after successful login. Restricted to `/*`. */
  next?: string;
}

function parseLoginSearch(input: Record<string, unknown>): LoginSearch {
  const next = input.next;
  return typeof next === 'string' ? { next } : {};
}

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/login',
  component: () => (
    <Suspense fallback={null}>
      <LoginPage />
    </Suspense>
  ),
  validateSearch: parseLoginSearch,
});
